var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        { staticClass: "mb-0", attrs: { state: false } },
        [
          _c(
            "b-card",
            {
              class: _vm.v.$invalid ? "form-invalid" : "form-valid",
              attrs: { "no-body": "" },
            },
            [
              _c(
                "b-card-body",
                [
                  _c("form-row-edit-text", {
                    attrs: {
                      v: _vm.v.supplier_reqs_a_text,
                      label:
                        "Укажите, каким требованиям должен соответствовать участник закупки",
                      compact: "",
                      "label-class": "my-0 py-0",
                    },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                  _c("span", { staticClass: "ml-1 fs-14" }, [
                    _vm._v(
                      "Укажите, какими документами участник закупки должен подтвердить соответствие указанным требованиям:"
                    ),
                  ]),
                  _c("b-table", {
                    staticClass: "table-atmo mb-0",
                    class: {
                      "form-invalid": _vm.v.supplier_reqs_a_documents.$invalid,
                    },
                    attrs: {
                      id: "my-table",
                      fields: _vm.fields,
                      items: _vm.items,
                      "show-empty": "",
                      small: "",
                      responsive: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "head(actions)",
                        fn: function () {
                          return [
                            _c("action-button-small", {
                              attrs: {
                                icon: "plus-square",
                                title: "Добавить описание документа",
                              },
                              on: { click: _vm.addItem },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "cell(index)",
                        fn: function (data) {
                          return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
                        },
                      },
                      {
                        key: "cell(description)",
                        fn: function (data) {
                          return [
                            _c("b-form-input", {
                              staticClass: "mb-0 form-control fs-14",
                              class: !_vm.v.supplier_reqs_a_documents.$each[
                                data.index
                              ].description.$invalid
                                ? "is-valid"
                                : "is-invalid",
                              model: {
                                value: data.item.description,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "description", $$v)
                                },
                                expression: "data.item.description",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c("action-button-small", {
                              attrs: { icon: "trash", title: "Удалить" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeItem(data.index)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "empty",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "w-100 text-center text-danger" },
                              [_vm._v("Добавьте описание документа")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }